// extracted by mini-css-extract-plugin
export default {"componentWrapper":"PositionsMobile_componentWrapper__HtUb+"};